import { createBrowserRouter } from 'react-router';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: Layout,
    children: [
      { index: true, lazy: () => import('./pages/HomePage').then(m => ({ Component: m.HomePage })) },
      { path: 'stories', lazy: () => import('./pages/StoryFeedPage').then(m => ({ Component: m.StoryFeedPage })) },
      { path: 'stories/:locationId', lazy: () => import('./pages/StoryFeedPage').then(m => ({ Component: m.StoryFeedPage })) },
      { path: 'story/:id', lazy: () => import('./pages/SharedStoryPage').then(m => ({ Component: m.SharedStoryPage })) },
      { path: 'debug', lazy: () => import('./pages/DebugStoriesPage').then(m => ({ Component: m.DebugStoriesPage })) },
      { path: 'debug/locations', lazy: () => import('./pages/LocationStatsPage').then(m => ({ Component: m.LocationStatsPage })) },
      { path: 'cloud', lazy: () => import('./pages/CloudIdentifierPage').then(m => ({ Component: m.CloudIdentifierPage })) },
      { path: 'bookmarks', lazy: () => import('./pages/BookmarksPage').then(m => ({ Component: m.BookmarksPage })) },
      { path: 'history/:locationId', lazy: () => import('./pages/HistoryPage').then(m => ({ Component: m.HistoryPage })) },
      { path: 'admin/features', lazy: () => import('./pages/FeatureParityPage').then(m => ({ Component: m.FeatureParityPage })) },
      { path: 'login', lazy: () => import('./pages/LoginPage').then(m => ({ Component: m.LoginPage })) },
      { path: 'register', lazy: () => import('./pages/RegisterPage').then(m => ({ Component: m.RegisterPage })) },
      { path: 'privacy', lazy: () => import('./pages/PrivacyPage').then(m => ({ Component: m.PrivacyPage })) },
      { path: 'terms', lazy: () => import('./pages/TermsPage').then(m => ({ Component: m.TermsPage })) },
      { path: 'contact', lazy: () => import('./pages/ContactPage').then(m => ({ Component: m.ContactPage })) },
      {
        Component: ProtectedRoute,
        children: [
          { path: 'settings', lazy: () => import('./pages/SettingsPage').then(m => ({ Component: m.SettingsPage })) },
          { path: 'subscription', lazy: () => import('./pages/SubscriptionPage').then(m => ({ Component: m.SubscriptionPage })) },
          { path: 'profile', lazy: () => import('./pages/ProfilePage').then(m => ({ Component: m.ProfilePage })) },
        ],
      },
      { path: '*', lazy: () => import('./pages/NotFoundPage').then(m => ({ Component: m.NotFoundPage })) },
    ],
  },
]);
